var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2966_5203",
    transform: "scale(0.0666667 0.0555556)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2966_5203",
    width: 15,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAAACXBIWXMAAAsTAAALEwEAmpwYAAACn0lEQVQ4jZWRS0hUURzGv3vu3Hk1mqXOhNFYNj5S0zTSdIQowaBoRC2DSCFSElr0IqKgXCRBi4KKyqSFGrjIHuKiRQ+SJidLzHQwKzMdzIF5OSjzuN55nFZ3Gkc3HjiL8/++3/n+538YSilWs4Q5QcNQynKJMqsEAPg5QW3pnmri1kvsqYbNHayM9cdCf15aTjrvTLRQe2ADAGT36gsYSilGrg095J/ZmwAAqdKJjAfFVeu2qMZE8O+wUz97fNAICgYAGCkRCvrL1QQA2CzF50iERUifuDl2Wzz6vaE4y8VvnSIIAIqKpB5ujWSeAMC2w5ldi1pmRBTph7kK24/5IoQpMZ391C6xBtJEjaQrxnSXcs8BACMOzDpqL7DUDZlIAHIACKfIZ0JSeLlpPksE5Uc3tuVezjnDSlkeAIgopOSph5kT2huRBCu/KRpUXci8kt+cd0oElyQDQDAQlg2WvrURb2ht9KRpTcrj3dfzG2N/gEQffAuBROILx8Wa0ht1t2Jry2DLq9l6UEpiTfbvC4UrwZG2PTa/1nzIOEo8S1sGgHAi58h5XrYzXi2fWZbsnvRsN9cPvF8JBADiCiR/bejv4X1B5ZLk4GJQPlhpNDMWvw4ABBXjkNRoO2XJCod7wFqs+rhQJZpDJQnvdt0vMnBy1gcAzPjTqcb55vE20cC1ZNQWVm/tBgBQMG9OGzvi+zx1kQvylKYdraUGZQLnIs5eyxFRENRkKr8y7cX/vkD33dU3+PTKbrHEjvpKzQf7xh1fnPtJyMUniYLsgKaLZZlQ9LtYCRHK7pXVB7NlpkjRHUy2Pfp9VcIoWS8QBpUgkFmre7LSwDg5y5d07Sl3Dbn3BlyLmpDNn6qp1rbiZ8/kMdN5U/uv19MGSilWs/8BEv8tVDeDcmkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.9f19f121d46d636b2869452be7047f95.svg";
export { ForwardRef as ReactComponent };